exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remove-button[data-v-46154b70] {\n    position: relative;\n    top: -5px;\n}\n.instructions[data-v-46154b70] {\n    line-height: 1.2em;\n    font-size: .90em;\n    font-style: italic;\n}\n.alert-condensed[data-v-46154b70] {\n    font-size: .90em;\n    line-height: 1.2em !important;\n}\n", ""]);

// exports
